import { useEffect } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { langState, langText } from "../../../recoil/lang";
import "../../../styles/CustomModal.css";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  RenderProductDetail: any;
  setSelectedProduct: any;
  selectedProduct: any;
  addCart: () => void;
  resetTimer: any;
};

const ProductDetailModal = ({
  isVisible,
  setVisible,
  RenderProductDetail,
  setSelectedProduct,
  addCart,
  selectedProduct,
  resetTimer,
}: Props) => {
  useEffect(() => {
    if (!isVisible) {
      setSelectedProduct([]);
    }
  }, [isVisible]);

  const onCloseModal = () => {
    setVisible(false);
  };

  const [lang, setLang] = useRecoilState<number>(langState);

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "prdDetailCustomOverlay",
        modal: "prdDetailCustomModal",
      }}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div onTouchStart={resetTimer} onScrollCapture={resetTimer}>
          <div className="optionWrap">
            <div className="optionTitle">
              <h2>{langText.productDetailModal_title[lang]}</h2>
              <button onClick={onCloseModal}>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/optionClose.svg`}
                  alt="옵션닫기"
                />
              </button>
            </div>
            <RenderProductDetail />
          </div>
          <div className="modalFooter">
            <button className="resetOptonButton" onClick={onCloseModal}>
              <h2>{langText.optionModal_button_ClearAll[lang]}</h2>
            </button>
            <button
              onClick={(e) => {
                addCart();
                setVisible(false);
              }}
            >
              <h2>{langText.optionModal_button_AddToCart[lang]}</h2>
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ProductDetailModal;

const Style = styled.div`
  .optionTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px 21px 25px 45px;

    h2 {
      font-size: 24px;
      font-weight: 300;
      color: #fff;
    }
  }

  /* 옵션 상세 설명 */
  .productDetailWrap {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 45px;
    margin: 30px 0 55px 0;

    .detailImgWrap {
      flex: 0 0 32%;

      img {
        width: 100%;
        height: 12vh;
      }
    }
    .detailTextWrap {
      flex: 0 0 65%;
      max-width: 65%;
      height: 100%;

      p {
        margin: 15px 0 0 0;
        font-size: 16px;
        font-weight: 400;
        color: #a7a7a7;
        line-height: 24px;
        word-break: keep-all;
        overflow-y: auto;
        max-height: 8vh;
      }
    }
    .detailImg {
      width: 100%;
      border-radius: 10px;
    }
  }
  .detailTextTitle {
    .detailName {
      flex: 1;
      margin-bottom: 16px;
    }
  }

  .modalFooter {
    width: 100%;
    padding: 34px 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #555555;
    background-color: #343434;

    button {
      width: 50%;
      margin: 0 5px;
      padding: 17px 0;
      border-radius: 10px;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
      outline: none;

      h2 {
        color: #fff;
        font-weight: 600;
        font-size: 24px;
      }
    }
    .resetOptonButton {
      background: #343434;
      border: 1px solid #777777;
    }
  }
`;
